import styles from './HomepageSearchInput.module.css';
import { useProductsHook, useSearchHook } from '../../../Hooks/use-context-hooks';

import { IconComponent } from '../../Icon/IconComponent';
import { useResponsiveStateHook } from '../../../Hooks/responsive-hook';
import {
    normalize,
    calculateMatchScore
} from '../../../Utils/search-helper';
import { useLanguageHook } from '../../../Hooks/use-context-hooks';

export const HomepageSearchInput = () => {

    const { publicProducts } = useProductsHook();
    const { isMobile, isDesktop } = useResponsiveStateHook();
    const productDataSearch = publicProducts;
    const { translatedText } = useLanguageHook();

    const { isHomepageSearchState, setIsHomepageSearchState } = useSearchHook();

    if (isHomepageSearchState.isHomepageSearch === true && isDesktop === true) {


        const handleHomepageSearchChange = (event) => {

            const query = event?.target?.value.toLowerCase();
            setIsHomepageSearchState(prevState => ({ ...prevState, isSearchInputValue: query }));

            if (query) {

                const queryWords = query?.trim()?.toLowerCase()?.split(/[\s-]+/)?.map(normalize);
                const queryJoined = queryWords.join('');

                // Filter products first
                const filteredResults = productDataSearch
                    .map(product => {
                        const matchScore = calculateMatchScore(product, queryWords, queryJoined);
                        return { product, matchScore };
                    })
                    .filter(({ matchScore }) => matchScore > 0) // Only matched products
                    .sort((a, b) => b.matchScore - a.matchScore) // Sort by highest score
                    .map(({ product }) => product); // Extract sorted products

                setIsHomepageSearchState(prevState => ({ ...prevState, isSearchResults: filteredResults }));

                // console.log(`Total matched products: ${filteredResults.length}`);

            } else {
                setIsHomepageSearchState(prevState => ({ ...prevState, isSearchResults: [] }));
            }
        }
        const handleHomepageSearchFocus = () => {
            setIsHomepageSearchState(prevState => ({ ...prevState, isSearchFocused: true }));
        }


        return (
            <div className={styles.searchInputContainer}>
                <div
                    className={`${styles.searchInputWrapper} ${isHomepageSearchState.isSearchActive ? styles.active : ''} ${isHomepageSearchState.isSearchResults.length > 0 ? styles.withResults : ''}`}
                >
                    <div className={styles.desktopSearchIconWrapper}>
                        <IconComponent iconType='searchInput' />
                    </div>

                    <input
                        type="search"
                        placeholder={translatedText.searchPLHA}
                        onChange={handleHomepageSearchChange}
                        value={isHomepageSearchState.isSearchInputValue}
                        onFocus={handleHomepageSearchFocus}
                        aria-label="Search home appliances"
                        // className={`${styles.input} ${isHomepageSearchState.isSearchActive ? styles.active : ''}`}
                        className={`${styles.input} ${isHomepageSearchState.isSearchActive ? styles.active : ''}${isHomepageSearchState.isSearchResults.length > 0 ? styles.withResults : ''}`}
                    />
                </div>
            </div>
        );
    }

    if (isHomepageSearchState.isHomepageSearch === true && isMobile === true) {

        return (
            <div className={styles.searchInputContainer}>
                <div
                    className={styles.searchInputWrapper}
                >
                    <div className={styles.desktopSearchIconWrapper}>
                        <IconComponent iconType='searchInput' />
                    </div>

                    {/* <input
                        type="search"
                        placeholder='Search home mobile appliances'

                        aria-label="Search home appliances"
                        className={styles.input}
                    /> */}
                </div>
            </div>
        );
    }

};